// The confirm dialog's icon slot is 76×76 (`dialog.module.scss` `.iconWrap`); the committed asset is
// 152×152 for retina, so it must be sized down explicitly. `z-index` lifts it over the header
// pattern, exactly as the shipped order-status confirm does.
.icon {
  z-index: 1;
  width: 76px;
  height: 76px;
  object-fit: contain;
}
